import React from 'react';
import styled from 'styled-components';
import {
    TableHead as MuiTableHead,
    TableRow,
    TableSortLabel,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import { THeadCell, TTableSortOrder } from 'common/types/table';

import { Checkbox } from '../Checkbox';

import { TableCell } from './TableCell';

interface IProps {
    className?: string;
    editable?: boolean;
    disableOrderBy?: boolean;
    order: TTableSortOrder;
    orderBy: string;
    rowCount: number;
    selectedRowAmount: number;
    tableHeadCells: THeadCell[];
    onSelectAllClick(e: React.ChangeEvent<HTMLInputElement>): void;
    onSort(headCellId: string, disableOrder?: boolean): void;
}

const BaseTableHead = ({
    className,
    editable,
    disableOrderBy,
    order,
    orderBy,
    rowCount,
    selectedRowAmount,
    tableHeadCells,
    onSelectAllClick,
    onSort,
}: IProps) => (
    <MuiTableHead className={className} component="div">
        <TableRow className="tableRow" component="div">
            {editable && (
                <TableCell className="checkboxCell tableCell">
                    <Checkbox
                        checked={rowCount > 0 && selectedRowAmount === rowCount}
                        indeterminate={
                            selectedRowAmount > 0 &&
                            selectedRowAmount < rowCount
                        }
                        onChange={onSelectAllClick}
                    />
                </TableCell>
            )}

            {tableHeadCells.map((headCell) => {
                const isActive = orderBy === headCell.id;

                return (
                    <TableCell className="tableCell" key={headCell.id}>
                        <TableSortLabel
                            active={isActive}
                            className={`headCellLabel ${
                                isActive ? 'active' : ''
                            } ${
                                (headCell.disableOrder || disableOrderBy) &&
                                !isActive
                                    ? 'disableOrderBy'
                                    : ''
                            }`}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            IconComponent={
                                isActive ? ExpandMoreIcon : ExpandLessIcon
                            }
                            onClick={() =>
                                onSort(headCell.id, headCell.disableOrder)
                            }
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                );
            })}
        </TableRow>
    </MuiTableHead>
);

export const TableHead = styled(BaseTableHead)`
    .tableCell {
        padding: ${({ theme }) => `0 0 ${theme.spacing(5)}px 0`};
        border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    }

    .MuiTableSortLabel-root.headCellLabel {
        color: ${({ theme }) => theme.palette.primary.main};

        .MuiTableSortLabel-icon {
            margin-left: ${({ theme }) => `${theme.spacing(2)}px`};
            font-size: 1.875rem;
        }

        &.disableOrderBy {
            opacity: 0.4;
            color: ${({ theme }) => theme.palette.text.secondary};
            cursor: initial;

            .MuiTableSortLabel-icon {
                display: none;
            }
        }

        &.active {
            color: ${({ theme }) => theme.palette.primary.main};
            font-weight: 800;
            opacity: 1;

            .MuiTableSortLabel-icon {
                color: ${({ theme }) => theme.palette.primary.main};
                font-weight: 800;
            }
        }
    }

    ${Checkbox} {
        padding-top: 6px;
    }
`;
